(function () {
  'use strict';

  window.VenucastSolutionFinderConfig = {
    version: 'prototype-2026-09-02-v5',

    products: {
      auraplex_m3: { handle: 'auraplex-m3-auracast-assistive-listening-kit', fallbackTitle: 'AuraPlex M3', trialEligible: true },
      auraplex_mx: { handle: 'auraplex-mx-auracast-wireless-transmitter-receiver', fallbackTitle: 'AuraPlex MX', trialEligible: true },
      auraplex_x20: { handle: 'auraplex-x20-pro-auracast-assistive-listening-system', fallbackTitle: 'AuraPlex X20 Pro', trialEligible: true },
      aircast: { handle: 'aircast-professional-auracast-transmitter', fallbackTitle: 'AirCast', trialEligible: true },
      netcast: { handle: 'netcast-enterprise-auracast-audio-distribution-system', fallbackTitle: 'NetCast', trialEligible: true },
      auraclip_3rx: { handle: 'auraclip-3rx-auracast-receiver-kit', fallbackTitle: 'AuraClip 3RX' },
      auraclip_10rx: { handle: 'auraclip-10rx-auracast-receiver-kit', fallbackTitle: 'AuraClip 10RX' },
      wired_headphones_3: { handle: '3-pack-wired-on-ear-headphones', fallbackTitle: '3-Pack Wired On-Ear Headphones' },
      wired_headphones_10: { handle: '10-pack-wired-on-ear-headphones', fallbackTitle: '10-Pack Wired On-Ear Headphones' },
      c83: { handle: 'c83-auracast-wireless-usb-c-receiver-for-phone', fallbackTitle: 'Aura C' },
      tcoil_390: { handle: '39091-auracast-receivers', fallbackTitle: '39091' },
      quartet_2: { handle: 'quartet-2-multi-user-wireless-headpones-system', fallbackTitle: 'Quartet 2' },
      quartet_extra: { handle: 'q5049-2-4g-headphones', fallbackTitle: 'Quartet-Extra' },
      quartet_charging: { handle: 'multi-charging-cable-for-quartet-type-c', fallbackTitle: 'Multi Charging Cable for Quartet' },
      ut90_transmitter: { handle: 'v-ut90-transmitter', fallbackTitle: 'V-UT90 Transmitter' },
      ut90_headphones_6: { handle: '6-pack-v-ut90-headphones', fallbackTitle: '6-Pack V-UT90 Headphones' },
      auditour: { handle: 'auditour-wireless-tour-guide-system', fallbackTitle: 'AudiTour' },
      auditour_expansion: { handle: 'auditour-expansion-kit', fallbackTitle: 'AudiTour Expansion Kit' },
      auditour_headphones_10: { handle: 'auditour-add-on-open-ear-headphones-10-pack', fallbackTitle: 'AudiTour Add-On Open-Ear Headphones (10-Pack)' }
    },

    useCases: [
      { value: 'assistive_listening', icon: '🦻', label: 'Assistive Listening', description: 'Help people hear speech or audio more clearly in a venue.' },
      { value: 'church', icon: '⛪', label: 'Church Hearing Assistance', description: 'Help congregation members hear the service.' },
      { value: 'classroom', icon: '🎓', label: 'Classroom / Education', description: 'Help students hear lectures, teachers or presentations.' },
      { value: 'theater', icon: '🎭', label: 'Theater / Auditorium', description: 'Provide personal listening for performances or presentations.' },
      { value: 'meeting', icon: '👥', label: 'Meeting / Conference', description: 'Provide accessible personal audio for meetings.' },
      { value: 'silent_event', icon: '🎧', label: 'Silent Event', description: 'Send audio directly to multiple headphones.' },
      { value: 'guided_tour', icon: '🎤', label: 'Guided Tour', description: "Send a guide's voice to a group." },
      { value: 'distributed_audio', icon: '📡', label: 'Venue / Distributed Audio', description: 'Send audio to speakers or listening devices around a venue.' },
      { value: 'not_sure', icon: '❓', label: "I'm Not Sure", description: 'Help me figure it out.' }
    ],

    listenerCounts: {
      standard: [
        { value: '1_3', label: '1–3', receiverQuantity: 3 },
        { value: '4_10', label: '4–10', receiverQuantity: 10 },
        { value: '11_20', label: '11–20', receiverQuantity: 20 },
        { value: '20_plus', label: '20+', receiverQuantity: null },
        { value: 'not_sure', label: "I'm not sure", receiverQuantity: null }
      ],
      group: [
        { value: '1_10', label: '1–10', receiverQuantity: 10 },
        { value: '11_30', label: '11–30', receiverQuantity: 30 },
        { value: '31_100', label: '31–100', receiverQuantity: 100 },
        { value: '100_plus', label: '100+', receiverQuantity: null },
        { value: 'not_sure', label: "I'm not sure", receiverQuantity: null }
      ]
    },

    listeningMethods: [
      { value: 'hearing_aids', icon: '🦻', label: 'Hearing aids', description: 'We’ll ask how the hearing aids connect next.' },
      { value: 'venucast_receivers', icon: '🎧', label: 'Venue-provided receivers and headphones', description: 'A ready-to-use option that the venue hands out.' },
      { value: 'own_bluetooth', icon: '📱', label: 'Their own Bluetooth earbuds', description: 'Use a phone as the bridge to the venue broadcast.' },
      { value: 'captions', icon: '💬', label: 'Caption text on a phone display', description: 'Show live caption text on a personal phone.' },
      { value: 'speakers', icon: '🔊', label: 'Speakers', description: 'Play the broadcast through installed or portable speakers.' },
      { value: 'not_sure', icon: '❓', label: "I'm not sure", description: 'Show a flexible starting point.' }
    ],

    hearingAidTypes: [
      { value: 'newer', icon: '✨', label: 'All or mostly newer hearing aids', description: 'Newer models may use Auracast or Bluetooth. You do not need to know the exact technology.' },
      { value: 'older', icon: '🦻', label: 'All or mostly older hearing aids', description: 'Older models are more likely to use T-Coil / telecoil.' },
      { value: 'mixed', icon: '🔀', label: 'A mix of newer and older hearing aids', description: 'Plan for venue receivers and T-Coil support, then confirm individual compatibility.' },
      { value: 'not_sure', icon: '❓', label: "I'm not sure", description: 'Use a mixed starting plan and confirm individual compatibility later.' }
    ],

    adaComplianceOptions: [
      { value: 'yes', icon: '✓', label: 'Yes — size for ADA planning', description: 'Use the venue capacity to calculate the receiver target. We will skip the separate listener-count question.' },
      { value: 'no', icon: '👥', label: 'No — size for expected demand', description: 'Use how many venue devices you expect to hand out; keep ADA as a reference.' },
      { value: 'not_sure', icon: '❓', label: "I'm not sure", description: 'Keep the reference visible and confirm with an expert.' }
    ],

    audioSources: [
      { value: 'professional_mixer', icon: '🎚️', label: 'Professional mixer / XLR' },
      { value: 'aux', icon: '🔌', label: 'AUX / headphone output' },
      { value: 'optical', icon: '📺', label: 'TV / optical audio' },
      { value: 'usb', icon: '💻', label: 'Computer / USB' },
      { value: 'microphone', icon: '🎤', label: 'Microphone / presenter' },
      { value: 'networked', icon: '🌐', label: 'Networked audio system' },
      { value: 'not_sure', icon: '❓', label: "I'm not sure" }
    ],

    sourceOptionsByUseCase: {
      guided_tour: ['microphone', 'aux', 'not_sure'],
      silent_event: ['professional_mixer', 'aux', 'usb', 'microphone', 'not_sure'],
      distributed_audio: ['professional_mixer', 'aux', 'networked', 'not_sure']
    },

    barriers: [
      { value: 'open', icon: '🏟️', label: 'One open area', description: 'Mostly clear line of sight between the transmitter and listeners.' },
      { value: 'light_partitions', icon: '🚪', label: 'Light partitions or interior walls', description: 'Drywall, curtains or movable partitions may reduce usable range.' },
      { value: 'concrete', icon: '🧱', label: 'Concrete walls or major separation', description: 'A managed multi-transmitter or networked design may be needed.' },
      { value: 'multiple_zones', icon: '🏢', label: 'Multiple rooms or listening zones', description: 'Audio must reach more than one distinct area.' },
      { value: 'not_sure', icon: '❓', label: "I'm not sure" }
    ],

    rules: [
      {
        id: 'guided-tour', enabled: true, priority: 140,
        conditions: { useCase: ['guided_tour'] },
        recommendation: {
          title: 'AudiTour group setup',
          subtitle: 'Portable guide transmitter, receivers and open-ear listening options',
          reasonBullets: ["Designed to send a guide's voice to a moving group", 'Expansion kits keep receiver quantities configurable', 'Open-ear add-ons provide a consistent venue-supplied listening option'],
          groups: {
            transmitter: [{ productId: 'auditour', quantity: 1, reason: 'Core portable transmitter and receiver system for the guide.' }],
            receivers: [
              { productId: 'auditour_expansion', quantity: 'groupPacks10', reason: 'Adds venue-provided receivers in groups of 10.' },
              { productId: 'auditour_headphones_10', quantity: 'groupPacks10', reason: 'Adds open-ear headphones for each receiver group.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'silent-event-large', enabled: true, priority: 135,
        conditions: { useCase: ['silent_event'], listenerCount: ['31_100', '100_plus'] },
        recommendation: {
          title: 'UT90 silent-event setup',
          subtitle: 'Multi-channel transmitter with expandable venue headphones',
          reasonBullets: ['Designed for larger silent events and conference listening', 'Six-headphone packs make the audience quantity easier to scale', 'Final channel and charging quantities should be confirmed for groups above 100'],
          groups: {
            transmitter: [{ productId: 'ut90_transmitter', quantity: 1, reason: 'Creates the wireless audio channel for the event.' }],
            receivers: [{ productId: 'ut90_headphones_6', quantity: 'groupPacks6', reason: 'Provides the wireless headphones people will wear.' }],
            accessories: []
          }
        }
      },
      {
        id: 'silent-event', enabled: true, priority: 130,
        conditions: { useCase: ['silent_event'] },
        recommendation: {
          title: 'Quartet 2 silent-listening setup',
          subtitle: 'Core transmitter plus expandable wireless headphones',
          reasonBullets: ['Built for multiple people listening at the same time', 'Works with common event audio sources', 'Extra headphones and charging cables can be added as the group grows'],
          groups: {
            transmitter: [{ productId: 'quartet_2', quantity: 1, reason: 'Core transmitter and starter headphone system.' }],
            receivers: [{ productId: 'quartet_extra', quantity: 'quartetExtras', reason: 'Adds one wireless listening headphone per additional person.' }],
            accessories: [{ productId: 'quartet_charging', quantity: 'quartetCharging', reason: 'Keeps larger headphone groups easier to charge.' }]
          }
        }
      },
      {
        id: 'segmented-or-networked', enabled: true, priority: 125,
        conditions: { any: [{ barriers: ['concrete', 'multiple_zones'] }, { audioSource: ['networked'] }, { useCase: ['distributed_audio'] }] },
        recommendation: {
          title: 'NetCast managed venue setup',
          subtitle: 'Networked transmitter design for separated spaces or multiple zones',
          reasonBullets: ['Concrete walls and separated zones can reduce usable wireless coverage', 'NetCast supports a more managed, expandable installation', 'A site plan is needed to confirm transmitter placement and quantity'],
          groups: {
            transmitter: [{ productId: 'netcast', quantity: 'sitePlan', reason: 'Creates managed broadcasts across the required coverage zones.' }],
            receivers: [
              { productId: 'auraclip_10rx', quantity: 'receiverPacks10', reason: 'Provides venue receivers in manageable groups of 10.' },
              { productId: 'wired_headphones_10', quantity: 'receiverPacks10', reason: 'Gives each AuraClip receiver a simple venue-provided listening option.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'over-one-thousand-seats', enabled: true, priority: 120,
        conditions: { minVenueCapacity: 1001 },
        recommendation: {
          title: 'NetCast large-venue setup',
          subtitle: 'Long-range managed transmitter with scalable receiver packs',
          reasonBullets: ['Mapped to venues above 1,000 seats', 'Published line-of-sight range is up to 656 ft, subject to layout and interference', 'Receiver packs scale from venue capacity and the requested listening-device count'],
          groups: {
            transmitter: [{ productId: 'netcast', quantity: 'sitePlan', reason: 'Provides the managed transmitter layer for a large venue.' }],
            receivers: [
              { productId: 'auraclip_10rx', quantity: 'receiverPacks10', reason: 'Provides venue receivers in groups of 10.' },
              { productId: 'wired_headphones_10', quantity: 'receiverPacks10', reason: 'Pairs a venue headphone with each AuraClip receiver.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'ada-m3-up-to-two-hundred-seats', enabled: true, priority: 119,
        conditions: { adaCompliance: ['yes'], minVenueCapacity: 151, maxVenueCapacity: 200 },
        recommendation: {
          title: 'AuraPlex M3 ADA receiver setup',
          subtitle: '5403 core kit with regular and T-Coil receiver packs sized from venue capacity',
          reasonBullets: ['Uses seating capacity instead of a broad expected-listener range', 'Combines regular AuraClip receivers with hearing-aid-compatible AuraCoil receivers', 'Sellable three-receiver packs may provide slightly more than the calculated ADA reference'],
          groups: {
            transmitter: [{ productId: 'auraplex_m3', quantity: 1, reason: 'The 5403 core kit combines the venue transmitter, three AuraClip receivers and charging.' }],
            receivers: [
              { productId: 'auraclip_3rx', quantity: 'adaM3StandardPacks3', reason: 'Adds three AuraClip receivers for visitors who do not use hearing aids or who prefer a venue-provided receiver.' },
              { productId: 'tcoil_390', quantity: 'adaM3TelecoilPacks3', reason: 'Adds three hearing-aid-compatible AuraCoil neck loop receivers for visitors whose hearing aids use T-Coil / telecoil.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'five-hundred-one-to-one-thousand-seats', enabled: true, priority: 115,
        conditions: { minVenueCapacity: 501, maxVenueCapacity: 1000 },
        recommendation: {
          title: 'AirCast large-room setup',
          subtitle: 'Professional transmitter with receiver and headphone packs sized to demand',
          reasonBullets: ['Mapped to venues between 501 and 1,000 seats', 'Published line-of-sight range is up to 500 ft, subject to walls and interference', 'Separate receiver packs make the venue listening quantity expandable'],
          groups: {
            transmitter: [{ productId: 'aircast', quantity: 1, reason: 'Provides the professional Auracast broadcast for the main room.' }],
            receivers: [
              { productId: 'auraclip_10rx', quantity: 'receiverPacks10', reason: 'Provides venue receivers in groups of 10.' },
              { productId: 'wired_headphones_10', quantity: 'receiverPacks10', reason: 'Pairs a venue headphone with each AuraClip receiver.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'twenty-plus-devices', enabled: true, priority: 110,
        conditions: { listenerCount: ['20_plus'] },
        recommendation: {
          title: 'AirCast expandable setup',
          subtitle: 'Professional transmitter with custom receiver and headphone quantities',
          reasonBullets: ['Built around a professional venue transmitter', 'Receiver and headphone packs can scale beyond 20 listeners', 'Final pack quantity should be confirmed with a solution advisor'],
          groups: {
            transmitter: [{ productId: 'aircast', quantity: 1, reason: 'Provides the main Auracast broadcast.' }],
            receivers: [
              { productId: 'auraclip_10rx', quantity: 'receiverPacks10', reason: 'Provides venue receivers in groups of 10.' },
              { productId: 'wired_headphones_10', quantity: 'receiverPacks10', reason: 'Pairs a venue headphone with each AuraClip receiver.' }
            ],
            accessories: []
          }
        }
      },
      {
        id: 'two-hundred-one-to-five-hundred-seats', enabled: true, priority: 105,
        conditions: { minVenueCapacity: 201, maxVenueCapacity: 500 },
        recommendation: {
          title: 'AuraPlex X20 Pro setup',
          subtitle: 'Long-range core system with 20 included listening devices',
          reasonBullets: ['Mapped to a 201–500 seat venue', 'Includes a managed mix of 20 listening devices and charging', 'Published line-of-sight range is up to 500 ft, subject to walls and interference'],
          groups: {
            transmitter: [{ productId: 'auraplex_x20', quantity: 1, reason: 'Combines the professional transmitter and a 20-device listener pool.' }],
            receivers: [{ productId: 'wired_headphones_10', quantity: 1, reason: 'Provides listening headphones for the 10 included AuraClip receivers.' }],
            accessories: []
          }
        }
      },
      {
        id: 'eleven-to-twenty-devices', enabled: true, priority: 100,
        conditions: { listenerCount: ['11_20'] },
        recommendation: {
          title: 'AuraPlex X20 Pro setup',
          subtitle: 'Core transmitter system with 20 included listening devices',
          reasonBullets: ['Sized for a venue-provided listening pool up to 20', 'Includes several listening styles plus charging', 'Compatible Auracast hearing aids can also receive the broadcast directly'],
          groups: {
            transmitter: [{ productId: 'auraplex_x20', quantity: 1, reason: 'Combines the transmitter and a 20-device listener pool.' }],
            receivers: [{ productId: 'wired_headphones_10', quantity: 1, reason: 'Provides listening headphones for the 10 included AuraClip receivers.' }],
            accessories: []
          }
        }
      },
      {
        id: 'fifty-one-to-two-hundred-seats', enabled: true, priority: 95,
        conditions: { minVenueCapacity: 51, maxVenueCapacity: 200 },
        recommendation: {
          title: 'AuraPlex MX setup',
          subtitle: 'Core transmitter system with 10 venue receivers',
          reasonBullets: ['Mapped to a 51–200 seat venue', 'Includes 10 venue receivers and a charging dock', 'Published line-of-sight range is up to 328 ft, subject to walls and interference'],
          groups: {
            transmitter: [{ productId: 'auraplex_mx', quantity: 1, reason: 'Combines the transmitter, 10 AuraClip receivers and charging.' }],
            receivers: [{ productId: 'wired_headphones_10', quantity: 1, reason: 'Pairs a venue headphone with each included AuraClip receiver.' }],
            accessories: []
          }
        }
      },
      {
        id: 'four-to-ten-devices', enabled: true, priority: 90,
        conditions: { listenerCount: ['4_10'] },
        recommendation: {
          title: 'AuraPlex MX setup',
          subtitle: 'Core transmitter system with 10 venue receivers',
          reasonBullets: ['Provides up to 10 venue receivers', 'Includes a charging dock for the receiver pool', 'Compatible Auracast hearing aids can also receive the broadcast directly'],
          groups: {
            transmitter: [{ productId: 'auraplex_mx', quantity: 1, reason: 'Combines the transmitter, 10 AuraClip receivers and charging.' }],
            receivers: [{ productId: 'wired_headphones_10', quantity: 1, reason: 'Pairs a venue headphone with each included AuraClip receiver.' }],
            accessories: []
          }
        }
      },
      {
        id: 'fallback', enabled: true, priority: 1,
        conditions: {},
        recommendation: {
          title: 'AuraPlex M3 starter setup',
          subtitle: 'Compact transmitter system with three venue receivers',
          reasonBullets: ['A compact starting point for a small venue or listening pool', 'Includes three AuraClip receivers', 'Published line-of-sight range is up to 328 ft, subject to walls and interference'],
          groups: {
            transmitter: [{ productId: 'auraplex_m3', quantity: 1, reason: 'Combines the transmitter and three AuraClip receivers.' }],
            receivers: [{ productId: 'wired_headphones_3', quantity: 1, reason: 'Pairs a venue headphone with each included AuraClip receiver.' }],
            accessories: []
          }
        }
      }
    ]
  };
})();
